<template>
  <v-navigation-drawer
    v-model="drawer"
    :mini-variant.sync="mini"
    app
    clipped
    width="230"
    dark
    color="#112A46"
    class="qp-nav-drawer"
  >
    <template v-slot:prepend>
      <SvgIcon
        class="p-t-6 p-b-3 justify-center"
        img-styles="width:80%;height:auto;max-width:80px"
        :icon="Logo"
      />
      <!--      <SvgIcon class="p-t-6 p-b-3 p-x-4" img-styles="width:80%;height:auto;max-width:80px" :icon="Logo"/>-->
    </template>
    <!--      <v-divider></v-divider>-->
    <v-list-item-group
      v-model="item"
      mandatory
      color="primary"
      class="navigation_krews"
    >
      <v-list-item
        v-for="link in links"
        :key="link.value"
        :value="link.value"
        link
        active-class="navbar-active"
        class="navbar-item"
        @click="menuNavigation(link.action)"
      >
        <SvgIcon class="gap-x-4" :text="link.label">
          <template #icon>
            <component component="svg" :is="link.icon" class="icon" />
          </template>
        </SvgIcon>
      </v-list-item>
      <!--      <v-divider></v-divider>-->
    </v-list-item-group>
  </v-navigation-drawer>
</template>
<script>
import { EventBus } from "../../main";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import DashboardIcon from "@/assets/images/navigation/dashboard.svg";
import UsersIcon from "@/assets/images/navigation/users.svg";
import VenuesIcon from "@/assets/images/navigation/venues.svg";
import EventsIcon from "@/assets/images/navigation/Events.svg";
import ServicesIcon from "@/assets/images/navigation/services.svg";
import SalesIcon from "@/assets/images/navigation/sales.svg";
import ReportsIcon from "@/assets/images/navigation/reports.svg";
import FeedPostIcon from "@/assets/images/navigation/feed-post.svg";
import InviteIcon from "@/assets/images/navigation/invite.svg";
import ModulesIcon from "@/assets/images/navigation/modules.svg";
import TournamentsIcon from "@/assets/images/navigation/tournaments.svg";
import PromotionsIcon from "@/assets/images/navigation/promotions.svg";
import EmployeesIcon from "@/assets/images/navigation/employees.svg";
import SponsoredPostIcon from "@/assets/images/navigation/sponsored-posts.svg";
import ExternalTickets from "@/assets/images/navigation/external-tickets.svg";
import Marketing from "@/assets/images/navigation/Marketing.svg";
import Logo from "@/assets/images/q-app-hd.png";

export default {
  components: {
    SvgIcon,
    DashboardIcon,
    UsersIcon,
    VenuesIcon,
    EventsIcon,
    ServicesIcon,
    SalesIcon,
    ReportsIcon,
    FeedPostIcon,
    InviteIcon,
    ModulesIcon,
    TournamentsIcon,
    PromotionsIcon,
    EmployeesIcon,
    SponsoredPostIcon,
    ExternalTickets,
    Marketing,
  },
  computed: {
    links() {
      return [
        {
          value: "dashboard",
          label: "Dashboard",
          icon: DashboardIcon,
          action: "Dashboard",
        },
        {
          value: "users",
          label: "Users",
          icon: UsersIcon,
          action: "Users",
        },
        {
          value: "venues",
          label: "Venues",
          icon: VenuesIcon,
          action: "Venues",
        },
        {
          value: "events",
          label: "Events",
          icon: EventsIcon,
          action: "Events",
        },
        {
          value: "services",
          label: "Services",
          icon: ServicesIcon,
          action: "Services",
        },
        // {
        //   "value": "transactions",
        //   "label": "VenueLog",
        //   "icon": ServicesIcon,
        //   "action": 'Transactions'
        // },
        // {
        //   "value": "clubs",
        //   "label": "Club",
        //   "icon": ServicesIcon,
        //   "action": 'Clubs'
        // },
        {
          value: "sales",
          label: "Sales",
          icon: SalesIcon,
          action: "Sales",
        },
        {
          value: "reported-posts",
          label: "Report",
          icon: ReportsIcon,
          action: "ReportedPosts",
        },
        {
          value: "feeds-graph",
          label: "Feed Post",
          icon: FeedPostIcon,
          action: "FeedsGraph",
        },
        {
          value: "invite",
          label: "Invite",
          icon: InviteIcon,
          action: "Invite",
        },
        {
          value: "modules",
          label: "Modules",
          icon: ModulesIcon,
          action: "Modules",
        },
        {
          value: "tournaments",
          label: "Tournaments",
          icon: TournamentsIcon,
          action: "Tournaments",
        },
        {
          value: "promotions",
          label: "Promotions",
          icon: PromotionsIcon,
          action: "Promotions",
        },
        {
          value: "employees",
          label: "Employees",
          icon: EmployeesIcon,
          action: "Employees",
        },
        {
          value: "sponsoredposts",
          label: "SponsoredPosts",
          icon: SponsoredPostIcon,
          action: "Sponsored Posts",
        },
        {
          value: "marketing",
          label: "Marketing",
          icon: Marketing,
          action: "Marketing",
        },
        {
          value: "externaltickets",
          label: "ExternalTickets",
          icon: ExternalTickets,
          action: "Upload External Tickets",
        },
      ];
    },
  },
  data: () => ({
    drawer: true,
    item: 0,
    mini: false,
    venue: {},
    Logo,
  }),
  created() {
    EventBus.$on("changeIt", (data) => {
      this.drawer = data;
    });
    this.venue = this.$store.getters.venueInfo;
    this.item = this.$route.meta.item;
  },
  watch: {
    $route() {
      this.item = this.$route.meta.item;
    },
  },
  methods: {
    menuNavigation(route) {
      if (this.$router.currentRoute.name != route) {
        this.$router.push({ name: route });
      }
    },
  },
};
</script>
<style scoped>
.navigation_krews {
  font-weight: 500;
}
.v-navigation-drawer {
  top: 0 !important;
  max-height: 100% !important;
}

.navbar-item {
  border-left: 6px solid transparent;
  border-bottom: none;
  font-size: 1rem;
  font-weight: 400;
  opacity: 0.6;
}

.navbar-active {
  background-color: #112a461a !important;
  border-left-color: #4faeaf;
  color: #ffffff !important;
  opacity: 1;
  font-weight: 500;
}

.navbar-active svg {
  stroke: #ffffff;
  stroke-width: 0.1;
  opacity: 1 !important;
}
</style>
